export interface LocTagInvite {
  id: string;
  name: string;
  budget: number;
}
export enum MealCreditInstanceType {
  DAILY = 'HOURS',
  WEEKLY = 'DAYS',
  MONTHLY = 'MONTHS',
}
type MealCreditOrderType = 'STANDARD' | 'CATERING' | 'GROUP';
type MealCreditFulfillmentType = 'PICKUP' | 'DELIVERY';
export interface ILineOfCreditResponseType {
  id: string;
  name: string;
  first_instance_utc: string;
  valid_days_of_week: number[]; // Days of week in which the event is valid, where Monday is 1 and Sunday is 7
  duration_minutes: number;
  expense_codes_enabled: boolean;
  expense_codes_required: boolean;
  fulfillment_types: MealCreditFulfillmentType[];
  instance_type: MealCreditInstanceType;
  locations: { [id: string]: string };
  valid_order_types: MealCreditOrderType[];
  budget_reset_period: number;
  tag_invites: LocTagInvite[];
  expiration: string | null;
  allocations_reporting_enabled: boolean;
  api_owner_type: string;
  billable_number_state: string;
  currency_code: string;
  diner_budgets: unknown;
  display_budgets: boolean;
  expense_codes_format: string;
  expense_comment_state: string;
  expense_comments_required: boolean;
  max_pickup_distance: number;
  order_cutoff_minutes: number;
  order_policy_acceptance_required: boolean;
  owner_client_id: string;
  owner_id: string;
  owner_name: string;
  owner_type?: string;
  predefined_reasons_enabled: boolean;
  prohibited_items: string[];
  repeating: boolean;
  send_loc_welcome_email: boolean;
}
export interface ILineOfCreditPayload {
  name: string;
  budget_reset_period: number; // 1 | 7
  first_instance_utc: string;
  diner_budget: number;
  valid_days_of_week: number[];
  instance_type: string;
  repeating: boolean;
}

export enum LineOfCreditAsyncTasks {
  UPDATE_BUDGET_BASIC_ACCOUNT = 'UPDATE_BUDGET_BASIC_ACCOUNT',
  CREATE_BUDGET_BASIC_ACCOUNT = 'CREATE_BUDGET_BASIC_ACCOUNT',
  DEACTIVATE_BUDGET_BASIC_ACCOUNT = 'DEACTIVATE_BUDGET_BASIC_ACCOUNT',
  UPDATE_GROUP_DINER_ASSOCIATIONS = 'UPDATE_GROUP_DINER_ASSOCIATIONS',
}

export interface ILocAddRemoveDiners {
  diners_to_add: string[];
  diners_to_remove: string[];
}

export interface BasicAccountBudgetGroupsRequest {
  budget_amount: number;
  group_ids: string[];
}

type Tych = {
  id: string;
  staticwebTychImageAltText: string;
  staticwebTychImageUrl: string;
  staticwebTychPrimaryText: string;
  staticwebTychSecondaryText: string;
};

export type ContentfulData = {
  staticwebThreeinfographPrimaryText: string;
  staticwebThreeinfographTychs: Tych[];
};
